import { ImageResolvedAssetSource, NativeEventEmitter } from 'react-native';
import { IAppStore } from '../../reducer';

export type MusicInitialiseStates = 'not-started' | 'started' | 'done';

export interface IPlaylist {
  id: string;
  uri: string;
  title: string;
  image?: string | ImageResolvedAssetSource;
}

export interface IPlayerState {
  isPaused: boolean;
  canSkipNext: boolean;
  canSkipPrevious: boolean;
  canToggleShuffle: boolean;
  isShuffling: boolean;
  currentSong: ISong;
}

export interface ISong {
  uri: string;
  id: string;
  title: string;
  artist: string;
  duration: number;
  isPlaying?: boolean;
  image?: string;
  thumbnail?: string;
}

export abstract class IMusicPlayerSource {
  protected readonly updatePlayerStateCallback: (playerState: IPlayerState) => void;
  protected readonly getAppState: () => IAppStore;
  protected readonly dispatch: (action: any) => void;

  public constructor(dispatch, getAppState, updatePlayerStateCallback) {
    this.getAppState = getAppState;
    this.dispatch = dispatch;
    this.updatePlayerStateCallback = updatePlayerStateCallback;
  }

  public abstract skipNext(): Promise<void>;

  public abstract skipPrevious(): Promise<void>;

  public abstract pause(): Promise<void>;

  public abstract play(): Promise<void>;

  public abstract setShuffling(shuffling: boolean): Promise<void>;

  public abstract playSong(song: ISong): Promise<void>;

  public abstract playPlaylist(playlist: IPlaylist): Promise<IPlayerState>;

  public abstract clean(): Promise<void>;

  public abstract initialize(): Promise<void>;

  public abstract loadUserPlaylists(): Promise<void>;

}

export interface IFBPlaylists {
  build: IPlaylist;
  burn: IPlaylist;
  balance: IPlaylist;
}
